import moment from 'moment';

const validate = (value, { min, format = 'DD/MM/YYYY' } = {}) => {
    var date = moment(value, format);
    var minDate = moment(min, format);

    return !date.isBefore(minDate);
};

const params = ['min','format'];

export {
    validate,
    params
};

export default {
    validate,
    params
};